module.exports = __webpack_public_path__ + "img/register3.3ed195f0.svg";